// extracted by mini-css-extract-plugin
export default {"combinedShieldRootV2":"combinedShieldRootV2___GFFEC","small":"small___CSQE8","s":"s___jmp9V","m":"m___N3D_U","l":"l___aPNGv","combinedShieldImgV2":"combinedShieldImgV2___RMsZL"};